var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","row":"","fill-height":""}},[(_vm.isMobile())?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"50","width":"2"}}):_c('v-progress-linear',{attrs:{"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }